// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-picker .react-time-picker,
.custom-picker .react-date-picker,
.custom-picker .react-datetime-picker,
.custom-picker .react-daterange-picker,
.custom-picker .react-datetimerange-picker {
  position: relative;
  width: 100%;
  min-width: 140px;
  height: 2.5rem;
  background-color: white;
  border: 1px solid #dadfe2;
  border-radius: 0.375rem;
  outline: 2px solid transparent;
  font-size: 14px;
  padding: 0px 8px;
}
.custom-picker .react-time-picker:not(.react-time-picker):focus-within,
.custom-picker .react-date-picker:not(.react-time-picker):focus-within,
.custom-picker .react-datetime-picker:not(.react-time-picker):focus-within,
.custom-picker .react-daterange-picker:not(.react-time-picker):focus-within,
.custom-picker .react-datetimerange-picker:not(.react-time-picker):focus-within {
  border-color: #54d2ff !important;
  outline-color: #cbf0fd;
}
.custom-picker .react-time-picker__wrapper,
.custom-picker .react-date-picker__wrapper,
.custom-picker .react-datetime-picker__wrapper,
.custom-picker .react-daterange-picker__wrapper,
.custom-picker .react-datetimerange-picker__wrapper {
  display: flex;
  gap: 4px;
  align-items: center;
  border: none !important;
}
.white-text .custom-picker .react-time-picker__wrapper input,
.white-text .custom-picker .react-time-picker__wrapper span,
.white-text .custom-picker .react-date-picker__wrapper input,
.white-text .custom-picker .react-date-picker__wrapper span,
.white-text .custom-picker .react-datetime-picker__wrapper input,
.white-text .custom-picker .react-datetime-picker__wrapper span,
.white-text .custom-picker .react-daterange-picker__wrapper input,
.white-text .custom-picker .react-daterange-picker__wrapper span,
.white-text .custom-picker .react-datetimerange-picker__wrapper input,
.white-text .custom-picker .react-datetimerange-picker__wrapper span {
  color: white;
}

.custom-picker .react-time-picker__wrapper button,
.custom-picker .react-date-picker__wrapper button,
.custom-picker .react-datetime-picker__wrapper button,
.custom-picker .react-daterange-picker__wrapper button,
.custom-picker .react-datetimerange-picker__wrapper button {
  padding: 0;
}
.custom-picker .react-time-picker__wrapper input:disabled,
.custom-picker .react-time-picker__wrapper button:disabled,
.custom-picker .react-date-picker__wrapper input:disabled,
.custom-picker .react-date-picker__wrapper button:disabled,
.custom-picker .react-datetime-picker__wrapper input:disabled,
.custom-picker .react-datetime-picker__wrapper button:disabled,
.custom-picker .react-daterange-picker__wrapper input:disabled,
.custom-picker .react-daterange-picker__wrapper button:disabled,
.custom-picker .react-datetimerange-picker__wrapper input:disabled,
.custom-picker .react-datetimerange-picker__wrapper button:disabled {
  cursor: not-allowed;
}
.custom-picker .react-time-picker__wrapper input:disabled svg,
.custom-picker .react-time-picker__wrapper button:disabled svg,
.custom-picker .react-date-picker__wrapper input:disabled svg,
.custom-picker .react-date-picker__wrapper button:disabled svg,
.custom-picker .react-datetime-picker__wrapper input:disabled svg,
.custom-picker .react-datetime-picker__wrapper button:disabled svg,
.custom-picker .react-daterange-picker__wrapper input:disabled svg,
.custom-picker .react-daterange-picker__wrapper button:disabled svg,
.custom-picker .react-datetimerange-picker__wrapper input:disabled svg,
.custom-picker .react-datetimerange-picker__wrapper button:disabled svg {
  cursor: not-allowed;
}
.custom-picker .react-time-picker__inputGroup,
.custom-picker .react-date-picker__inputGroup,
.custom-picker .react-datetime-picker__inputGroup,
.custom-picker .react-daterange-picker__inputGroup,
.custom-picker .react-datetimerange-picker__inputGroup {
  height: unset !important;
}
.react-daterange-picker .custom-picker .react-time-picker__inputGroup:first-of-type,
.react-daterange-picker .custom-picker .react-date-picker__inputGroup:first-of-type,
.react-daterange-picker .custom-picker .react-datetime-picker__inputGroup:first-of-type,
.react-daterange-picker .custom-picker .react-daterange-picker__inputGroup:first-of-type,
.react-daterange-picker .custom-picker .react-datetimerange-picker__inputGroup:first-of-type {
  flex-grow: 0;
}

.react-datetimerange-picker .custom-picker .react-time-picker__inputGroup:first-of-type,
.react-datetimerange-picker .custom-picker .react-date-picker__inputGroup:first-of-type,
.react-datetimerange-picker .custom-picker .react-datetime-picker__inputGroup:first-of-type,
.react-datetimerange-picker .custom-picker .react-daterange-picker__inputGroup:first-of-type,
.react-datetimerange-picker .custom-picker .react-datetimerange-picker__inputGroup:first-of-type {
  flex-grow: 0;
}

.custom-picker .react-time-picker__inputGroup__input, .custom-picker .react-time-picker__inputGroup__leadingZero,
.custom-picker .react-date-picker__inputGroup__input,
.custom-picker .react-date-picker__inputGroup__leadingZero,
.custom-picker .react-datetime-picker__inputGroup__input,
.custom-picker .react-datetime-picker__inputGroup__leadingZero,
.custom-picker .react-daterange-picker__inputGroup__input,
.custom-picker .react-daterange-picker__inputGroup__leadingZero,
.custom-picker .react-datetimerange-picker__inputGroup__input,
.custom-picker .react-datetimerange-picker__inputGroup__leadingZero {
  height: unset !important;
  outline-color: #B9E6FE;
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}

.custom-picker .react-time-picker__inputGroup__input::placeholder, .custom-picker .react-time-picker__inputGroup__leadingZero::placeholder,
.custom-picker .react-date-picker__inputGroup__input::placeholder,
.custom-picker .react-date-picker__inputGroup__leadingZero::placeholder,
.custom-picker .react-datetime-picker__inputGroup__input::placeholder,
.custom-picker .react-datetime-picker__inputGroup__leadingZero::placeholder,
.custom-picker .react-daterange-picker__inputGroup__input::placeholder,
.custom-picker .react-daterange-picker__inputGroup__leadingZero::placeholder,
.custom-picker .react-datetimerange-picker__inputGroup__input::placeholder,
.custom-picker .react-datetimerange-picker__inputGroup__leadingZero::placeholder {
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.custom-picker .react-time-picker__inputGroup__divider, .custom-picker .react-time-picker__inputGroup__amPm,
.custom-picker .react-date-picker__inputGroup__divider,
.custom-picker .react-date-picker__inputGroup__amPm,
.custom-picker .react-datetime-picker__inputGroup__divider,
.custom-picker .react-datetime-picker__inputGroup__amPm,
.custom-picker .react-daterange-picker__inputGroup__divider,
.custom-picker .react-daterange-picker__inputGroup__amPm,
.custom-picker .react-datetimerange-picker__inputGroup__divider,
.custom-picker .react-datetimerange-picker__inputGroup__amPm {
  --tw-text-opacity: 1 !important;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1)) !important;
}
.filled .custom-picker .react-time-picker__inputGroup__divider, .filled .custom-picker .react-time-picker__inputGroup__amPm,
.filled .custom-picker .react-date-picker__inputGroup__divider,
.filled .custom-picker .react-date-picker__inputGroup__amPm,
.filled .custom-picker .react-datetime-picker__inputGroup__divider,
.filled .custom-picker .react-datetime-picker__inputGroup__amPm,
.filled .custom-picker .react-daterange-picker__inputGroup__divider,
.filled .custom-picker .react-daterange-picker__inputGroup__amPm,
.filled .custom-picker .react-datetimerange-picker__inputGroup__divider,
.filled .custom-picker .react-datetimerange-picker__inputGroup__amPm {
  --tw-text-opacity: 1 !important;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1)) !important;
}

.custom-picker .react-time-picker__range-divider,
.custom-picker .react-date-picker__range-divider,
.custom-picker .react-datetime-picker__range-divider,
.custom-picker .react-daterange-picker__range-divider,
.custom-picker .react-datetimerange-picker__range-divider {
  margin: 0 4px 2px 4px;
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.filled .custom-picker .react-time-picker__range-divider,
.filled .custom-picker .react-date-picker__range-divider,
.filled .custom-picker .react-datetime-picker__range-divider,
.filled .custom-picker .react-daterange-picker__range-divider,
.filled .custom-picker .react-datetimerange-picker__range-divider {
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}

.custom-picker .react-time-picker__button,
.custom-picker .react-date-picker__button,
.custom-picker .react-datetime-picker__button,
.custom-picker .react-daterange-picker__button,
.custom-picker .react-datetimerange-picker__button {
  padding: 0;
  margin-left: auto;
}
.filled .custom-picker .react-time-picker__button,
.filled .custom-picker .react-date-picker__button,
.filled .custom-picker .react-datetime-picker__button,
.filled .custom-picker .react-daterange-picker__button,
.filled .custom-picker .react-datetimerange-picker__button {
  margin-left: 6px;
}

.filled .custom-picker .react-time-picker__clear-button,
.filled .custom-picker .react-date-picker__clear-button,
.filled .custom-picker .react-datetime-picker__clear-button,
.filled .custom-picker .react-daterange-picker__clear-button,
.filled .custom-picker .react-datetimerange-picker__clear-button {
  margin-left: auto;
  padding-left: 8px;
}

.custom-picker .react-time-picker--disabled,
.custom-picker .react-date-picker--disabled,
.custom-picker .react-datetime-picker--disabled,
.custom-picker .react-daterange-picker--disabled,
.custom-picker .react-datetimerange-picker--disabled {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1)) !important;
  border-radius: 0.375rem;
}
.custom-picker .react-time-picker__calendar,
.custom-picker .react-date-picker__calendar,
.custom-picker .react-datetime-picker__calendar,
.custom-picker .react-daterange-picker__calendar,
.custom-picker .react-datetimerange-picker__calendar {
  opacity: 0;
  margin-top: 4px;
  margin-bottom: 12px;
}
.custom-picker .react-time-picker__calendar[data-placement=top] > .react-calendar,
.custom-picker .react-date-picker__calendar[data-placement=top] > .react-calendar,
.custom-picker .react-datetime-picker__calendar[data-placement=top] > .react-calendar,
.custom-picker .react-daterange-picker__calendar[data-placement=top] > .react-calendar,
.custom-picker .react-datetimerange-picker__calendar[data-placement=top] > .react-calendar {
  transform-origin: bottom;
}
.custom-picker .react-time-picker__calendar--closed,
.custom-picker .react-date-picker__calendar--closed,
.custom-picker .react-datetime-picker__calendar--closed,
.custom-picker .react-daterange-picker__calendar--closed,
.custom-picker .react-datetimerange-picker__calendar--closed {
  display: block;
  transition: none;
}
.isDocumentation .custom-picker .react-time-picker__calendar,
.isDocumentation .custom-picker .react-date-picker__calendar,
.isDocumentation .custom-picker .react-datetime-picker__calendar,
.isDocumentation .custom-picker .react-daterange-picker__calendar,
.isDocumentation .custom-picker .react-datetimerange-picker__calendar {
  display: none !important;
}

.custom-picker .react-time-picker.iconIsRight .react-date-picker__button:first-of-type,
.custom-picker .react-time-picker.iconIsRight .react-datetime-picker__button:first-of-type,
.custom-picker .react-time-picker.iconIsRight .react-daterange-picker__button:first-of-type,
.custom-picker .react-time-picker.iconIsRight .react-datetimerange-picker__button:first-of-type,
.custom-picker .react-date-picker.iconIsRight .react-date-picker__button:first-of-type,
.custom-picker .react-date-picker.iconIsRight .react-datetime-picker__button:first-of-type,
.custom-picker .react-date-picker.iconIsRight .react-daterange-picker__button:first-of-type,
.custom-picker .react-date-picker.iconIsRight .react-datetimerange-picker__button:first-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-date-picker__button:first-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-datetime-picker__button:first-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-daterange-picker__button:first-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-datetimerange-picker__button:first-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-date-picker__button:first-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-datetime-picker__button:first-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-daterange-picker__button:first-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-datetimerange-picker__button:first-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-date-picker__button:first-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetime-picker__button:first-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-daterange-picker__button:first-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetimerange-picker__button:first-of-type {
  order: 4;
}
.custom-picker .react-time-picker.iconIsRight .react-date-picker__button:last-of-type,
.custom-picker .react-time-picker.iconIsRight .react-datetime-picker__button:last-of-type,
.custom-picker .react-time-picker.iconIsRight .react-daterange-picker__button:last-of-type,
.custom-picker .react-time-picker.iconIsRight .react-datetimerange-picker__button:last-of-type,
.custom-picker .react-date-picker.iconIsRight .react-date-picker__button:last-of-type,
.custom-picker .react-date-picker.iconIsRight .react-datetime-picker__button:last-of-type,
.custom-picker .react-date-picker.iconIsRight .react-daterange-picker__button:last-of-type,
.custom-picker .react-date-picker.iconIsRight .react-datetimerange-picker__button:last-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-date-picker__button:last-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-datetime-picker__button:last-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-daterange-picker__button:last-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-datetimerange-picker__button:last-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-date-picker__button:last-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-datetime-picker__button:last-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-daterange-picker__button:last-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-datetimerange-picker__button:last-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-date-picker__button:last-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetime-picker__button:last-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-daterange-picker__button:last-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetimerange-picker__button:last-of-type {
  order: 0;
  margin-right: 4px;
  margin-left: unset;
}
.custom-picker .react-time-picker.iconIsRight .react-date-picker__inputGroup:first-of-type,
.custom-picker .react-time-picker.iconIsRight .react-datetime-picker__inputGroup:first-of-type,
.custom-picker .react-time-picker.iconIsRight .react-daterange-picker__inputGroup:first-of-type,
.custom-picker .react-time-picker.iconIsRight .react-datetimerange-picker__inputGroup:first-of-type,
.custom-picker .react-date-picker.iconIsRight .react-date-picker__inputGroup:first-of-type,
.custom-picker .react-date-picker.iconIsRight .react-datetime-picker__inputGroup:first-of-type,
.custom-picker .react-date-picker.iconIsRight .react-daterange-picker__inputGroup:first-of-type,
.custom-picker .react-date-picker.iconIsRight .react-datetimerange-picker__inputGroup:first-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-date-picker__inputGroup:first-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-datetime-picker__inputGroup:first-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-daterange-picker__inputGroup:first-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-datetimerange-picker__inputGroup:first-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-date-picker__inputGroup:first-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-datetime-picker__inputGroup:first-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-daterange-picker__inputGroup:first-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-datetimerange-picker__inputGroup:first-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-date-picker__inputGroup:first-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetime-picker__inputGroup:first-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-daterange-picker__inputGroup:first-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetimerange-picker__inputGroup:first-of-type {
  order: 1;
}
.custom-picker .react-time-picker.iconIsRight .react-date-picker__inputGroup:last-of-type,
.custom-picker .react-time-picker.iconIsRight .react-datetime-picker__inputGroup:last-of-type,
.custom-picker .react-time-picker.iconIsRight .react-daterange-picker__inputGroup:last-of-type,
.custom-picker .react-time-picker.iconIsRight .react-datetimerange-picker__inputGroup:last-of-type,
.custom-picker .react-date-picker.iconIsRight .react-date-picker__inputGroup:last-of-type,
.custom-picker .react-date-picker.iconIsRight .react-datetime-picker__inputGroup:last-of-type,
.custom-picker .react-date-picker.iconIsRight .react-daterange-picker__inputGroup:last-of-type,
.custom-picker .react-date-picker.iconIsRight .react-datetimerange-picker__inputGroup:last-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-date-picker__inputGroup:last-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-datetime-picker__inputGroup:last-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-daterange-picker__inputGroup:last-of-type,
.custom-picker .react-datetime-picker.iconIsRight .react-datetimerange-picker__inputGroup:last-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-date-picker__inputGroup:last-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-datetime-picker__inputGroup:last-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-daterange-picker__inputGroup:last-of-type,
.custom-picker .react-daterange-picker.iconIsRight .react-datetimerange-picker__inputGroup:last-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-date-picker__inputGroup:last-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetime-picker__inputGroup:last-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-daterange-picker__inputGroup:last-of-type,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetimerange-picker__inputGroup:last-of-type {
  order: 3;
}
.custom-picker .react-time-picker.iconIsRight .react-date-picker__range-divider,
.custom-picker .react-time-picker.iconIsRight .react-datetime-picker__range-divider,
.custom-picker .react-time-picker.iconIsRight .react-daterange-picker__range-divider,
.custom-picker .react-time-picker.iconIsRight .react-datetimerange-picker__range-divider,
.custom-picker .react-date-picker.iconIsRight .react-date-picker__range-divider,
.custom-picker .react-date-picker.iconIsRight .react-datetime-picker__range-divider,
.custom-picker .react-date-picker.iconIsRight .react-daterange-picker__range-divider,
.custom-picker .react-date-picker.iconIsRight .react-datetimerange-picker__range-divider,
.custom-picker .react-datetime-picker.iconIsRight .react-date-picker__range-divider,
.custom-picker .react-datetime-picker.iconIsRight .react-datetime-picker__range-divider,
.custom-picker .react-datetime-picker.iconIsRight .react-daterange-picker__range-divider,
.custom-picker .react-datetime-picker.iconIsRight .react-datetimerange-picker__range-divider,
.custom-picker .react-daterange-picker.iconIsRight .react-date-picker__range-divider,
.custom-picker .react-daterange-picker.iconIsRight .react-datetime-picker__range-divider,
.custom-picker .react-daterange-picker.iconIsRight .react-daterange-picker__range-divider,
.custom-picker .react-daterange-picker.iconIsRight .react-datetimerange-picker__range-divider,
.custom-picker .react-datetimerange-picker.iconIsRight .react-date-picker__range-divider,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetime-picker__range-divider,
.custom-picker .react-datetimerange-picker.iconIsRight .react-daterange-picker__range-divider,
.custom-picker .react-datetimerange-picker.iconIsRight .react-datetimerange-picker__range-divider {
  order: 2;
}
.custom-picker .react-time-picker .react-date-picker__calendar--open,
.custom-picker .react-time-picker .react-datetime-picker__calendar--open,
.custom-picker .react-time-picker .react-daterange-picker__calendar--open,
.custom-picker .react-time-picker .react-datetimerange-picker__calendar--open,
.custom-picker .react-date-picker .react-date-picker__calendar--open,
.custom-picker .react-date-picker .react-datetime-picker__calendar--open,
.custom-picker .react-date-picker .react-daterange-picker__calendar--open,
.custom-picker .react-date-picker .react-datetimerange-picker__calendar--open,
.custom-picker .react-datetime-picker .react-date-picker__calendar--open,
.custom-picker .react-datetime-picker .react-datetime-picker__calendar--open,
.custom-picker .react-datetime-picker .react-daterange-picker__calendar--open,
.custom-picker .react-datetime-picker .react-datetimerange-picker__calendar--open,
.custom-picker .react-daterange-picker .react-date-picker__calendar--open,
.custom-picker .react-daterange-picker .react-datetime-picker__calendar--open,
.custom-picker .react-daterange-picker .react-daterange-picker__calendar--open,
.custom-picker .react-daterange-picker .react-datetimerange-picker__calendar--open,
.custom-picker .react-datetimerange-picker .react-date-picker__calendar--open,
.custom-picker .react-datetimerange-picker .react-datetime-picker__calendar--open,
.custom-picker .react-datetimerange-picker .react-daterange-picker__calendar--open,
.custom-picker .react-datetimerange-picker .react-datetimerange-picker__calendar--open {
  width: unset;
  display: flex;
}
.custom-picker .react-time-picker .react-date-picker__calendar--open .react-calendar,
.custom-picker .react-time-picker .react-datetime-picker__calendar--open .react-calendar,
.custom-picker .react-time-picker .react-daterange-picker__calendar--open .react-calendar,
.custom-picker .react-time-picker .react-datetimerange-picker__calendar--open .react-calendar,
.custom-picker .react-date-picker .react-date-picker__calendar--open .react-calendar,
.custom-picker .react-date-picker .react-datetime-picker__calendar--open .react-calendar,
.custom-picker .react-date-picker .react-daterange-picker__calendar--open .react-calendar,
.custom-picker .react-date-picker .react-datetimerange-picker__calendar--open .react-calendar,
.custom-picker .react-datetime-picker .react-date-picker__calendar--open .react-calendar,
.custom-picker .react-datetime-picker .react-datetime-picker__calendar--open .react-calendar,
.custom-picker .react-datetime-picker .react-daterange-picker__calendar--open .react-calendar,
.custom-picker .react-datetime-picker .react-datetimerange-picker__calendar--open .react-calendar,
.custom-picker .react-daterange-picker .react-date-picker__calendar--open .react-calendar,
.custom-picker .react-daterange-picker .react-datetime-picker__calendar--open .react-calendar,
.custom-picker .react-daterange-picker .react-daterange-picker__calendar--open .react-calendar,
.custom-picker .react-daterange-picker .react-datetimerange-picker__calendar--open .react-calendar,
.custom-picker .react-datetimerange-picker .react-date-picker__calendar--open .react-calendar,
.custom-picker .react-datetimerange-picker .react-datetime-picker__calendar--open .react-calendar,
.custom-picker .react-datetimerange-picker .react-daterange-picker__calendar--open .react-calendar,
.custom-picker .react-datetimerange-picker .react-datetimerange-picker__calendar--open .react-calendar {
  order: 1;
  box-shadow: none;
  flex-shrink: 0;
}
.custom-picker .react-time-picker .react-date-picker__calendar--closed,
.custom-picker .react-time-picker .react-datetime-picker__calendar--closed,
.custom-picker .react-time-picker .react-daterange-picker__calendar--closed,
.custom-picker .react-time-picker .react-datetimerange-picker__calendar--closed,
.custom-picker .react-date-picker .react-date-picker__calendar--closed,
.custom-picker .react-date-picker .react-datetime-picker__calendar--closed,
.custom-picker .react-date-picker .react-daterange-picker__calendar--closed,
.custom-picker .react-date-picker .react-datetimerange-picker__calendar--closed,
.custom-picker .react-datetime-picker .react-date-picker__calendar--closed,
.custom-picker .react-datetime-picker .react-datetime-picker__calendar--closed,
.custom-picker .react-datetime-picker .react-daterange-picker__calendar--closed,
.custom-picker .react-datetime-picker .react-datetimerange-picker__calendar--closed,
.custom-picker .react-daterange-picker .react-date-picker__calendar--closed,
.custom-picker .react-daterange-picker .react-datetime-picker__calendar--closed,
.custom-picker .react-daterange-picker .react-daterange-picker__calendar--closed,
.custom-picker .react-daterange-picker .react-datetimerange-picker__calendar--closed,
.custom-picker .react-datetimerange-picker .react-date-picker__calendar--closed,
.custom-picker .react-datetimerange-picker .react-datetime-picker__calendar--closed,
.custom-picker .react-datetimerange-picker .react-daterange-picker__calendar--closed,
.custom-picker .react-datetimerange-picker .react-datetimerange-picker__calendar--closed {
  display: none;
}
.custom-picker .react-datetimerange-picker__inputGroup__amPm {
  --tw-text-opacity: 1 !important;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1)) !important;
}
.custom-picker .react-datetimerange-picker.filled .custom-picker .react-datetimerange-picker__inputGroup__amPm {
  --tw-text-opacity: 1 !important;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1)) !important;
}
.custom-picker .react-daterange-picker__inputGroup,
.custom-picker .react-datetimerange-picker__inputGroup {
  flex-grow: 0;
}
.custom-picker .react-time-picker {
  max-width: max-content;
  min-width: max-content;
  border: none;
  padding: 0;
}
.custom-picker .react-time-picker__inputGroup {
  position: relative;
  min-width: max-content;
}
.custom-picker .react-time-picker__inputGroup__amPm {
  margin-left: 2px;
  appearance: none;
  background-image: none;
  --tw-text-opacity: 1 !important;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1)) !important;
}
.custom-picker .react-time-picker__inputGroup__divider:last-of-type {
  display: none !important;
}
.is-options .custom-picker .react-time-picker__inputGroup__amPm {
  font-style: unset !important;
  appearance: none !important;
  cursor: pointer;
}

.custom-picker .react-time-picker__wrapper {
  flex-grow: 0;
  width: 100%;
}
.custom-picker .react-time-picker.is-options {
  min-width: 74px;
  max-width: unset;
  border: none !important;
  outline: none !important;
  padding: 0 !important;
}
.custom-picker .react-time-picker__clock {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/shared/DateInputPicker/lib/DateInputPicker.scss"],"names":[],"mappings":"AAEE;;;;;EAKE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAIM;;;;;EACE,gCAAA;EACA,sBAAA;AAER;AAEI;;;;;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;AAIN;AAFQ;;;;;;;;;;EAEE,YAAA;AAYV;;AARM;;;;;EACE,UAAA;AAeR;AAXQ;;;;;;;;;;EACE,mBAAA;AAsBV;AArBU;;;;;;;;;;EACE,mBAAA;AAgCZ;AA3BI;;;;;EACE,wBAAA;AAiCN;AA/BQ;;;;;EACE,YAAA;AAqCV;;AAjCQ;;;;;EACE,YAAA;AAwCV;;AArCM;;;;;;;;;EAEE,wBAAA;EACA,sBAAA;EACA,oBAAA;EAAA,gDAAA;AAgDR;;AA/CQ;;;;;;;;;EAAA,oBAAA;EAAA;AAAA;AAIA;;;;;;;;;EAAA,+BAAA;EAAA;AAAA;AAEE;;;;;;;;;EAAA,+BAAA;EAAA;AAAA;;AAIN;;;;;EACE,qBAAA;EACA,oBAAA;EAAA,mDAAA;AAkEN;AAhEQ;;;;;EAAA,oBAAA;EAAA;AAAA;;AAIJ;;;;;EACE,UAAA;EACA,iBAAA;AA0EN;AAzEe;;;;;EACP,gBAAA;AA+ER;;AA1Ee;;;;;EACP,iBAAA;EACA,iBAAA;AAiFR;;AA5EM;;;;;EAAA,6BAAA;EAAA,uEAAA;EACA;AADA;AAIF;;;;;EACE,UAAA;EACA,eAAA;EACA,mBAAA;AAuFN;AApFM;;;;;EACE,wBAAA;AA0FR;AAvFM;;;;;EACE,cAAA;EACA,gBAAA;AA6FR;AA1Fe;;;;;EACP,wBAAA;AAgGR;;AAtFU;;;;;;;;;;;;;;;;;;;;EACE,QAAA;AA4GZ;AA1GU;;;;;;;;;;;;;;;;;;;;EACE,QAAA;EACA,iBAAA;EACA,kBAAA;AA+HZ;AA3HU;;;;;;;;;;;;;;;;;;;;EACE,QAAA;AAgJZ;AA9IU;;;;;;;;;;;;;;;;;;;;EACE,QAAA;AAmKZ;AAhKQ;;;;;;;;;;;;;;;;;;;;EACE,QAAA;AAqLV;AAhLI;;;;;;;;;;;;;;;;;;;;EAIE,YAAA;EACA,aAAA;AAkMN;AAjMM;;;;;;;;;;;;;;;;;;;;EACE,QAAA;EACA,gBAAA;EACA,cAAA;AAsNR;AAlNI;;;;;;;;;;;;;;;;;;;;EAIE,aAAA;AAoON;AA9NM;EAAA,+BAAA;EAAA;AAAA;AAGA;EAAA,+BAAA;EAAA;AAAA;AAMF;;EACE,YAAA;AA8NN;AA1NE;EACE,sBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;AA4NJ;AA1NI;EACE,kBAAA;EACA,sBAAA;AA4NN;AA3NM;EACE,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;EAAA,2DAAA;AA6NR;AA1NQ;EACE,wBAAA;AA4NV;AAxNQ;EACE,4BAAA;EACA,2BAAA;EACA,eAAA;AA0NV;;AArNI;EACE,YAAA;EACA,WAAA;AAwNN;AArNI;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;AAuNN;AArNI;EACE,aAAA;AAuNN","sourcesContent":["@use '../../../../styles/lib' as lib;\n.custom-picker {\n  .react-time-picker,\n  .react-date-picker,\n  .react-datetime-picker,\n  .react-daterange-picker,\n  .react-datetimerange-picker {\n    position: relative;\n    width: 100%;\n    min-width: 140px;\n    @apply h-10;\n    background-color: white;\n    border: 1px solid #dadfe2;\n    @apply rounded-md;\n    outline: 2px solid transparent;\n    font-size: 14px;\n    padding: 0px 8px;\n\n    &:not(.react-time-picker) {\n      &:focus-within {\n        border-color: #54d2ff !important;\n        outline-color: #cbf0fd;\n      }\n    }\n\n    &__wrapper {\n      display: flex;\n      gap: 4px;\n      align-items: center;\n      border: none !important;\n      @at-root .white-text & {\n        input,\n        span {\n          color: white;\n        }\n      }\n\n      button {\n        padding: 0;\n      }\n      input,\n      button {\n        &:disabled {\n          cursor: not-allowed;\n          svg {\n            cursor: not-allowed;\n          }\n        }\n      }\n    }\n    &__inputGroup {\n      height: unset !important;\n      @at-root .react-daterange-picker & {\n        &:first-of-type {\n          flex-grow: 0;\n        }\n      }\n      @at-root .react-datetimerange-picker & {\n        &:first-of-type {\n          flex-grow: 0;\n        }\n      }\n      &__input,\n      &__leadingZero {\n        height: unset !important;\n        @apply outline-[#B9E6FE];\n        @apply text-neutral-800;\n        @apply placeholder:text-neutral-500;\n      }\n      &__divider,\n      &__amPm {\n        @apply text-neutral-500 !important;\n        @at-root .filled & {\n          @apply text-neutral-800 !important;\n        }\n      }\n    }\n    &__range-divider {\n      margin: 0 4px 2px 4px;\n      @apply text-neutral-500;\n      @at-root .filled & {\n        @apply text-neutral-800;\n      }\n    }\n\n    &__button {\n      padding: 0;\n      margin-left: auto;\n      @at-root .filled & {\n        margin-left: 6px;\n      }\n    }\n\n    &__clear-button {\n      @at-root .filled & {\n        margin-left: auto;\n        padding-left: 8px;\n      }\n    }\n\n    &--disabled {\n      @apply bg-neutral-50 !important;\n      @apply rounded-md;\n    }\n\n    &__calendar {\n      opacity: 0;\n      margin-top: 4px;\n      margin-bottom: 12px;\n\n      // Flipped above the field: grow upward out of it instead of dropping down.\n      &[data-placement='top'] > .react-calendar {\n        transform-origin: bottom;\n      }\n\n      &--closed {\n        display: block;\n        transition: none;\n      }\n\n      @at-root .isDocumentation & {\n        display: none !important;\n      }\n    }\n\n    &.iconIsRight {\n      .react-date-picker,\n      .react-datetime-picker,\n      .react-daterange-picker,\n      .react-datetimerange-picker {\n        &__button {\n          &:first-of-type {\n            order: 4;\n          }\n          &:last-of-type {\n            order: 0;\n            margin-right: 4px;\n            margin-left: unset;\n          }\n        }\n        &__inputGroup {\n          &:first-of-type {\n            order: 1;\n          }\n          &:last-of-type {\n            order: 3;\n          }\n        }\n        &__range-divider {\n          order: 2;\n        }\n      }\n    }\n\n    .react-date-picker__calendar--open,\n    .react-datetime-picker__calendar--open,\n    .react-daterange-picker__calendar--open,\n    .react-datetimerange-picker__calendar--open {\n      width: unset;\n      display: flex;\n      .react-calendar {\n        order: 1;\n        box-shadow: none;\n        flex-shrink: 0;\n      }\n    }\n\n    .react-date-picker__calendar--closed,\n    .react-datetime-picker__calendar--closed,\n    .react-daterange-picker__calendar--closed,\n    .react-datetimerange-picker__calendar--closed {\n      display: none;\n    }\n  }\n\n  .react-datetimerange-picker {\n    &__inputGroup__amPm {\n      @apply text-neutral-500 !important;\n    }\n    &.filled &__inputGroup__amPm {\n      @apply text-neutral-800 !important;\n    }\n  }\n\n  .react-daterange-picker,\n  .react-datetimerange-picker {\n    &__inputGroup {\n      flex-grow: 0;\n    }\n  }\n\n  .react-time-picker {\n    max-width: max-content;\n    min-width: max-content;\n    border: none;\n    padding: 0;\n\n    &__inputGroup {\n      position: relative;\n      min-width: max-content;\n      &__amPm {\n        margin-left: 2px;\n        appearance: none;\n        background-image: none;\n        @apply text-neutral-800 !important;\n      }\n      &__divider {\n        &:last-of-type {\n          display: none !important;\n        }\n      }\n      @at-root .is-options & {\n        &__amPm {\n          font-style: unset !important;\n          appearance: none !important;\n          cursor: pointer;\n        }\n      }\n    }\n\n    &__wrapper {\n      flex-grow: 0;\n      width: 100%;\n    }\n\n    &.is-options {\n      min-width: 74px;\n      max-width: unset;\n      border: none !important;\n      outline: none !important;\n      padding: 0 !important;\n    }\n    &__clock {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
